import { SearchCrmoOrderSummary } from 'domain/usecases/surgical-order/search-crmo-order-summary'
import { SurgicalOrderRepository } from 'repository/interfaces/surgical-order-repository'

export class RemoteSearchCrmoOrderSummary implements SearchCrmoOrderSummary {
  constructor(
    private readonly surgicalOrderRepository: SurgicalOrderRepository
  ) {}

  load(
    params: SearchCrmoOrderSummary.Params
  ): Promise<SearchCrmoOrderSummary.Model> {
    return this.surgicalOrderRepository.searchCrmoOrderSummary(params)
  }
}
